/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'HorizontalScrollBlock';
const CLS = 'horizontalScrollBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/horizontalScrollBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import PerfectScrollbar from 'perfect-scrollbar';
import utils from '../utils';

export class HorizontalScrollBlock {
	constructor($el) {
		// $el is the widget node return by the loadHorizontalScrollBlock function
		this.$el = $el;
	}

	init() {
		this.setHorizontalScrollBlock();
	}

	setHorizontalScrollBlock() {
		const $wg = $(this.$el);

		let scrollSpeed = 20;
		let scroller = $wg[0];
		let scrollerItems = $wg.find(WG + 'items')[0];

		new PerfectScrollbar(scrollerItems, {
			minScrollbarLength: 100,
			maxScrollbarLength: 200,
		});

		scroller.addEventListener('mousewheel', (e) => {
			if (!e.deltaY) return;

			if ($wg.offset().top - $(window).scrollTop() !== 0) return;

			let scrollDirection = (e.deltaY > 0) ? 1 : -1;

			scrollerItems.scrollLeft += scrollSpeed * scrollDirection;

			let scrollLeft = Math.round(scrollerItems.scrollLeft);
			let maxScrollLeft = Math.round(scrollerItems.scrollWidth - scrollerItems.clientWidth);

			if (
				(scrollDirection === -1 && scrollLeft > 0) ||
				(scrollDirection === 1 && scrollLeft < maxScrollLeft)
			) e.preventDefault();

			return true;
		}, false);
	}

	// Add more functions like on above here
}
